export default __webpack_public_path__ + "static/media/DownloadCSV.2da4bb0d.svg";